import report from './report.json';

export default { ...report };
